
export default {
  name: 'PartnerLocatorDirectory',
  props: {
    groups: {
      type: Array,
      default: () => [],
    },
  },
}
